// LoadingLottie.tsx
import React from 'react';
import LottieAnimation from './LottieAnimation';

interface LoadingLottieProps {
  minHeight?: string;
}

const LoadingLottie: React.FC<LoadingLottieProps> = ({ minHeight = 'min-h-[100vh]' }) => (
  <div className={`${minHeight} w-full flex items-center justify-center`}>
    <div className="w-20 h-20 md:w-28 md:h-28">
      <LottieAnimation
        path="/loading-lottie-A.json"
        width="100%"
        height="100%"
      />
    </div>
  </div>
);

export default LoadingLottie;
